<template>
    <div>
        <vs-popup
                class="deliverer-modal"
                :title="getTitle"
                :active.sync="showPopup"
                v-if="company !== null"
        >
            <template>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Naam"
                                :value="company.name"
                                v-model="company.name"
                        />
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Postcode"
                                :value="company.postal_code"
                                v-model="company.postal_code"
                        />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Postcode"
                                :value="company.housenumber"
                                v-model="company.housenumber"
                        />
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Adres"
                                disabled
                                v-model="company.address"
                        />
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Telefoonnummer"
                                :value="company.phone_number"
                                v-model="company.phone_number"
                        />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Intern Telefoonnummer"
                                :value="company.internal_phone_number"
                                v-model="company.internal_phone_number"
                        />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="E-mail"
                                :value="company.email"
                                v-model="company.email"
                        />
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-1/3">
                        <vs-button radius color="danger" type="filled" icon-pack="feather" icon="icon-archive"  @click="saveModel(company)"></vs-button>
                    </div>
                </div>
            </template>
        </vs-popup>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                showPopup: false,
                company: null
            }
        },

        mounted() {
            this.$events.listen('open-company-modal', (company) => {
                this.showPopup = true;
                this.company = company;
                console.log(this.company);
            })
        },
        computed: {
            getTitle: function() {
                if(null !== this.company.name) {
                    return this.company.name;
                }
                return 'Vul een bedrijfsnaam in'
            }
        },

        watch: {
            'company.housenumber': function() {
                // this.getAddress();
            },
        },

        methods: {
            saveModel(company) {

            },
            getAddress: function () {
                if(this.company.housenumber === '' || this.company.postal_code === '') {
                    return;
                }
                this.$http.get("https://staffapi.hebtrek.nl/v1/address?api_token=" + JSON.parse(localStorage.getItem("stafftoken")), {
                    params: {
                        zipcode: this.company.postal_code,
                        number: this.company.housenumber
                    }
                })
                    .then((response) => {
                        this.company.address = response.data.street + " " + response.data.number + ", " + response.data.postcode + ", " + response.data.city
                    }).catch((error) => {
                });
            },
        }
    }
</script>